export default {
  methods: {
    formataTextoMonetario(valor) {
      if (valor == undefined) {
        return 'Sem valor';
      }
      var formato = {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        style: 'currency',
        currency: 'BRL'
      }
      return valor.toLocaleString('pt-BR', formato)
    },
    formataTextoDecimalBrasil(valor) {
      if (valor == undefined) {
        return 'Sem valor';
      }
      var formato = {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }
      return valor.toLocaleString('pt-BR', formato)
    },
    formataTextoBoolean(valor) {
      if (valor == undefined) {
        return 'Sem valor';
      }

      if (valor === false) {
        return "Não";
      }

      if (valor === true) {
        return "Sim";
      }
    },
    formataTextoString(valor) {
      if (valor == undefined) {
        return 'Sem valor';
      }
      return valor;
    },
    formataTextoInteger(valor) {
      if (valor == undefined) {
        return 'Sem valor';
      }
      return parseInt(valor);
    },
    formataTextoData(valor) {
      if (valor == undefined) {
        return 'Sem valor';
      }

      var date = new Date(valor);
      var options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      };
      return date.toLocaleDateString('pt-BR', options);
    },
    formataTextoDataHora(valor) {

      if (valor == undefined) {
        return 'Sem valor';
      }

      var date = new Date(valor);
      var options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'America/Sao_Paulo',
      };
      return date.toLocaleDateString('pt-BR', options);
    },
    stringIsDecimalValue(value) {
      return !!(value % 1);
    }
  }
}



// WEBPACK FOOTER //
// ./src/util/mixins.js